import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import "react-sliding-pane/dist/react-sliding-pane.css";
import DatePicker from "react-datepicker";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import ContentLoader from "react-content-loader";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";
import SlidingPane from "react-sliding-pane";
import axios from "axios";

import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import AddProcessingService from "../../../services/Processing/createProcessing";
import Scheduler from "../../schedule";
import { useLocation } from "react-router-dom";

function GenerateAgingBucket({ id, setContract_number,
  showScheduler,
  setScheduleType,
  scheduleType,
  setShowScheduler,
  startDate, setSchedule,
  setStartDate,
  setStartTime,
  startTime,
  setRerunUnit,
  setSelectedMonths,
  setSelectedDates,
  setSelectedWeekdays,
  setIncrementParams,
  setFrequency,
  incrementParams,
  setRecalculateParams,
  recalculateParams,
  rerunUnit,
  setEndDate,
  endDate,
  setEndTime,
  endTime,
  setRerunInterval,
  rerunInterval,
  selectedMonths,
  selectedDates,
  selectedWeekdays,
  frequency,
  setIsLoading,
  isLoading,
  setMoniter,
  moniter
}) {
  const GenrateBuckettableRef = React.useRef();
  const [selectedValue3, setSelectedValue3] = useState("");
  const [flag, setFlag] = useState("");
  const [flagNotification, setFlagNotification] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputvalue, setValue] = useState("");
  const [successful, setSuccessful] = useState(false);
  const [disable, setDisable] = useState(false);
  const [billtroughdate, setBillTroughDate] = useState(new Date());
  // const [moniter, setMoniter] = useState("Bucket");
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');

  let localDateTime = new Date();
  let startDateValue = localDateTime.toISOString().split('T')[0];
  const location = useLocation()
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);
  const [isLoading2, setIsLoading2] = useState(false);

  let state = location.state
  const checkBtn = useRef();
  const {
    handleSubmit,
  } = useForm();
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [bucketloading, setBucketLoading] = useState(true);

  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API + `contracts/contractsactive/filter/?id=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };
  const handelInputChange = (value) => {
    setValue(value);
  };
  const handelChange = (value) => {
    setSelectedValue(value);
    setContract_number(value)
  };

  const hadelRefresh = () => {
    GenrateBuckettableRef.current.onQueryChange();
    setBillTroughDate(new Date())

  };
  const handleReset = () => {
    setSelectedValue3("");
    GenrateBuckettableRef.current.onQueryChange();
  };
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const handelChangebilling = (value) => {
    setSelectedValue3(value);
  };

  useEffect(() => {
    setBucketLoading(false);
  }, [id]);
  const loadOptionsbilling = async () => {
    GenrateBuckettableRef.current.onQueryChange();
  };

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    setDisable(true);

    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddProcessingService.addProcessing(
        selectedValue ? selectedValue.id : "",
        moniter,
        billtroughdate.toISOString().split("T")[0]
      ).then((response) => {
        if (response.data.success) {
          if (response.data.billing) {
            setFlag(flag + 1);
          } else {
            setFlagNotification(flagNotification + 1);
            setLoading(false);
          }
          setSuccessful(true);
          setSelectedValue("");
          setBillTroughDate(new Date());
          axios.post(API + 'helper/schedule-task/', {
            "task_type": "instant",
            "process_name": moniter
          },
            {
              headers: authHeader()
            }
          ).then((res) => {
            setStartDate('')
            setEndDate('')
            setFrequency('')
            setStartTime('')
            setEndTime('')
          })
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            setDisable(false);
            GenrateBuckettableRef.current.onQueryChange();
          }, 1000);
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
          setDisable(false);
        }
      })
    }
  };

  const handleschedule = () => {
    if (scheduleType === 'once') {
      const localDateTime = new Date(`${startDate}T${startTime}:00`)
      const taskTime = localDateTime.toISOString().split('.')[0] + 'Z';
      const value = {
        task_type: 'specific',
        task_time: taskTime,
        process_name: moniter,
        parameter1: selectedValue ? selectedValue.id : "",
        parameter2: billtroughdate.toISOString().split("T")[0],
        start_date: startDate !== '' ? startDate : startDateValue,
      }
      axios.post(API + 'helper/schedule-task/', value,
        {
          headers: authHeader()
        }
      ).then((res) => {
        if (res.data.success === 1) {
          setStartDate('')
          setEndDate('')
          setFrequency('')
          setStartTime('')
          setEndTime('')
          setIsLoading(false)
          toast.success(res.data.response)
          setTimeout(() => {
            setShowScheduler(false)
            GenrateBuckettableRef.current.onQueryChange();
          }, 1000);
        }
      }).catch((e) => {
        setIsLoading(false)
      })
      // }
    } else {
      const formattedStartDate = `${startDate} ${startTime}`;
      const formattedEndDate = `${endDate} ${endTime}`;
      const localDateTime = new Date(`${startDate}T${startTime}`);
      const taskTime = localDateTime.toISOString().split('.')[0] + 'Z'
      // const startMonth = new Date(startDate).getMonth(); 
      // const startMonthName = months[startMonth];

      // const finalMonths = selectedMonths.length === 0 ? [startMonthName] : selectedMonths;
      if (rerunInterval === '') {
        const value = {
          task_type: 'custom',
          task_time: taskTime,
          interval_type: rerunUnit,
          interval_value: rerunInterval,
          start_date: formattedStartDate,
          end_date: formattedEndDate,
          // month: finalMonths,
          month: selectedMonths,
          days_of_month: selectedDates,
          days_of_week: selectedWeekdays,
          process_name: moniter,
          parameter1: selectedValue ? selectedValue.id : "",
          parameter2: startDate !== '' ? startDate : startDateValue,
        }
        axios.post(API + 'helper/schedule-task/', value,
          {
            headers: authHeader()
          }
        ).then((res) => {
          if (res.data.success) {
            setStartDate('')
            setEndDate('')
            setFrequency('')
            setStartTime('')
            setEndTime('')
            setIsLoading(false)
            setTimeout(() => {
              setShowScheduler(false)
              GenrateBuckettableRef.current.onQueryChange();
            }, 1000);
          }
        }).catch((e) => {
          setIsLoading(false)
        })
      } else {
        const value = {
          task_type: 'periodic',
          task_time: taskTime,
          interval_type: rerunUnit,
          interval_value: rerunInterval,
          start_date: formattedStartDate,
          process_name: moniter,
          parameter1: selectedValue ? selectedValue.id : "",
          parameter2: billtroughdate.toISOString().split("T")[0],
        }
        axios.post(API + 'helper/schedule-task/', value,
          {
            headers: authHeader()
          }
        ).then((res) => {
          if (res.data.success) {
            toast.success(res.data.response)
            setStartDate('')
            setEndDate('')
            setFrequency('')
            setStartTime('')
            setEndTime('')
            setIsLoading(false)
            setTimeout(() => {
              setShowScheduler(false)
              GenrateBuckettableRef.current.onQueryChange();
            }, 1000);
          }
        }).catch((e) => {
          setIsLoading(false)
        })
      }
    }
    setShowScheduler(false)
  }

  useEffect(() => {
    if (state !== '') {
      setSelectedValue(state)
    }
  }, [state])

  return (
    <>
      <div className="page-wrapper">
        <ToastContainer />
        <div className=" container-fluid">
          {bucketloading === false ? (
            <div className="row">
              <div className="row" id="payschedule" style={{ marginTop: "10px" }}>
                <Form
                  role="form text-left"
                  // onSubmit={handleSubmit(handleRegister)}
                  ref={form}
                  action="."
                  method="POST"
                // id="addrForm"
                >
                  {
                    <>
                      <div className="row">
                        <div className="col-xl-4 processingindex">
                          {/* <div className="form-group row">
                            <label className="col-lg-5 col-form-label">
                              {t("Contract Number")}
                            </label>
                            <div className="col-lg-9">
                              <AsyncSelect
                                defaultOptions
                                isClearable
                                value={selectedValue}
                                placeholder={t("Search for Contract(%for All)")}
                                getOptionLabel={(e) => e.contract_number}
                                getOptionValue={(e) => e.contract_number}
                                loadOptions={loadOptions}
                                onInputChange={handelInputChange}
                                onChange={handelChange}
                              ></AsyncSelect>

                              <input
                                type="hidden"
                                id="contract_status"
                                value=""
                              />
                            </div>
                          </div> */}
                        </div>
                        <div className="col-xl-3">
                          {/* <div className="form-group row">
                            <label className="col-lg-5 col-form-label">
                              {t("Send Through Date")}
                            </label>
                            <div className="col-lg-9">
                              <DatePicker
                                className="form-control datepick"
                                selected={billtroughdate}
                                onChange={(e) => setBillTroughDate(e)}
                                placeholderText={"mm/dd/yyyy"}
                                showYearDropdown // year show and scrolldown alos
                                scrollableYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                              />
                            </div>
                          </div> */}
                        </div>
                        <div className="col-xl-4">
                          <div className="form-group row">
                            <div
                              className="col-lg-12 text-right"
                              style={{ marginTop: "30px" }}
                            >
                              <button
                                type="button"
                                className="refreshRequest btn bg-gradient-secondary ms-auto mb-0"
                                onClick={hadelRefresh}
                              >
                                {t("Refresh")}
                              </button>
                              &nbsp;&nbsp;
                              {

                                permissionss && permissionsArray.includes('add_processing') === true ?
                                  <button
                                    type="button"
                                    className="requestBilling btn btn-primary ms-auto mb-0"
                                    onClick={() => setShowScheduler(true)}
                                  >
                                    {
                                      // t("Apply")
                                      // t("Run Now")
                                      t("Schedule")
                                    }
                                  </button>
                                  : ""
                              }
                              &nbsp;&nbsp;
                            </div>
                            {showScheduler &&
                              <Scheduler
                                showScheduler={showScheduler}
                                setShowScheduler={setShowScheduler}
                                handleschedule={handleschedule}
                                setIsLoading={setIsLoading}
                                isLoading={isLoading}
                                setMoniter={setMoniter}
                                setValue2={setValue}
                                inputvalue2={inputvalue}
                                setIsLoading2={setIsLoading2}
                                options2={options2}
                                isLoading2={isLoading2}
                                setCurrentPage2={setCurrentPage2}
                                setOptions2={setOptions2}
                                currentPage2={currentPage2}
                                onSave={() => {
                                  setIsLoading(true)
                                  form.current.validateAll();
                                  if (checkBtn.current.context._errors.length === 0) {
                                    AddProcessingService.addProcessing(
                                      selectedValue ? selectedValue.id : "",
                                      moniter,
                                      billtroughdate.toISOString().split("T")[0]
                                    ).then((response) => {
                                      if (response.data.success) {
                                        if (response.data.billing) {
                                          setFlag(flag + 1);
                                        } else {
                                          setFlagNotification(flagNotification + 1);
                                          // setLoading(false);
                                        }
                                        setSuccessful(true);
                                        setSelectedValue("");
                                        // setBillTroughDate(new Date());
                                        axios.post(API + 'helper/schedule-task/', {
                                          "task_type": "instant",
                                          "process_name": moniter
                                        },
                                          {
                                            headers: authHeader()
                                          }
                                        ).then((res) => {
                                          if (res.data.success === 1) {
                                            setStartDate('')
                                            setEndDate('')
                                            setFrequency('')
                                            setStartTime('')
                                            setEndTime('')
                                            setIsLoading(false)
                                          }
                                        }).catch((e) => {
                                          setIsLoading(false)
                                        })
                                        toast.success(`${response.data.response}`, {
                                          position: "top-right",
                                          autoClose: 1000,
                                          hideProgressBar: false,
                                          pauseOnHover: true,
                                          draggable: true,
                                          progress: undefined,
                                          theme: "light",
                                        });
                                        setTimeout(() => {
                                          setDisable(false);
                                          setIsLoading(false)
                                          setShowScheduler(false)

                                          GenrateBuckettableRef.current.onQueryChange();
                                        }, 1000);
                                      } else {
                                        toast.error(`${response.data.error}`, {
                                          position: "top-right",
                                          autoClose: 1000,
                                          hideProgressBar: false,
                                          pauseOnHover: true,
                                          draggable: true,
                                          progress: undefined,
                                          theme: "light",
                                        });
                                        setSuccessful(false);
                                        setDisable(false);
                                        setIsLoading(false)
                                      }
                                    })
                                   
                                  }
                                }}
                                setScheduleType={setScheduleType}
                                scheduleType={scheduleType}
                                setStartDate={setStartDate}
                                startDate={startDate}
                                setStartTime={setStartTime}
                                startTime={startTime}
                                setEndDate={setEndDate}
                                endDate={endDate}
                                setEndTime={setEndTime}
                                endTime={endTime}
                                setRerunInterval={setRerunInterval}
                                rerunInterval={rerunInterval}
                                setRerunUnit={setRerunUnit}
                                rerunUnit={rerunUnit}
                                setSelectedMonths={setSelectedMonths}
                                selectedMonths={selectedMonths}
                                setSelectedDates={setSelectedDates}
                                selectedDates={selectedDates}
                                setFrequency={setFrequency}
                                frequency={frequency}
                                setSelectedWeekdays={setSelectedWeekdays}
                                selectedWeekdays={selectedWeekdays}
                                setIncrementParams={setIncrementParams}
                                incrementParams={incrementParams}
                                setRecalculateParams={setRecalculateParams}
                                recalculateParams={recalculateParams}
                                setSchedule={setSchedule}
                                moniter={moniter}
                                selectedValue={selectedValue}
                                billtroughdate={billtroughdate}
                                GenrateBilltableRef={GenrateBuckettableRef}
                                setSelectedValue={setSelectedValue}
                                setContract_number={setContract_number}

                              />
                            }
                          </div>
                        </div>
                        <div className="col-xl-1 form-group row pt-4">
                          <span
                            className="text-right"
                            onClick={() => setState({ isPaneOpen: true })}
                            style={{
                              color: "#b4b7c5",
                              paddingRight: "1px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/images/ic-filter.svg"
                              }
                              alt=""
                            />
                          </span>
                        </div>
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
                <SlidingPane
                  className="some-custom-class"
                  overlayClassName="some-custom-overlay-class"
                  isOpen={state1.isPaneOpen}
                  title="Filter By"
                  subtitle=""
                  onRequestClose={() => {
                    setState({ isPaneOpen: false });
                  }}
                >
                  <div className="col-md-12">
                    <div className="">
                      <div className="">
                        <div className="col-lg-12 mb-3">
                          <label className="col-lg-5 col-form-label">
                            {t("Request Date")}
                          </label>
                          <DatePicker
                            className="form-control datepick"
                            selected={selectedValue3}
                            onChange={(e) => handelChangebilling(e)}
                            placeholderText={"mm/dd/yyyy"}
                            showYearDropdown // year show and scrolldown alos
                            scrollableYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <button
                        type="button"
                        className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
                        onClick={handleReset}
                      >
                        {t("Reset")}
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={loadOptionsbilling}
                        className="partyFilter add btn btn-primary ms-auto mb-0"
                      >
                        {t("Apply")}
                      </button>
                      &nbsp;&nbsp;
                    </div>
                  </div>
                </SlidingPane>
                <div className="col-md-12">
                  <div className="">
                    <div className="body">
                      <div className="table-responsive">
                        <MaterialTable
                          tableRef={GenrateBuckettableRef}
                          style={{
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                          }}
                          columns={[
                            {
                              title: `${t("Request ID")}`,
                              field: "id",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Request ID")}{" "}
                                  </div>
                                  <div>{rowData.id}</div>
                                </>
                              ),
                              defaultSort: "desc",
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },

                            {
                              title: `${t("Process Name")}`,
                              field: "process_name",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Process Name")}{" "}
                                  </div>
                                  <div>{rowData.process_name}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Contract Number")}`,
                              field: "parameter1",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Contract Number")}{" "}
                                  </div>
                                  <div>{rowData.parameter1 ? rowData.parameter1 : "None"}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            // {
                            //   title: `${t("Send Through Date")}`,
                            //   field: "parameter2",
                            //   render: (rowData) => (
                            //     <>
                            //       <div className="d-xl-none tc d-md-none d-lg-none">
                            //         {t("Send Through Date")}
                            //       </div>
                            //       <div>
                            //         {Helper.DateNormal(rowData.parameter2)}
                            //       </div>
                            //     </>
                            //   ),
                            //   headerStyle: {
                            //     verticalAlign: "inherit",
                            //     fontWeight: "bold",
                            //     textAlign: "left",
                            //   },
                            //   cellStyle: {
                            //     textAlign: "left",
                            //     fontSize: 12,
                            //   },
                            // },
                            {
                              title: `${t("Request Date")}`,
                              field: "request_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Request Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.request_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Status")}`,
                              field: "status",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Status")}
                                  </div>
                                  <div
                                    className={
                                      rowData.status === "success"
                                        ? "badge bg-gradient-success text-xxs"
                                        : "badge badge-sm bg-gradient-secondary"
                                    }
                                  >
                                    {rowData.status}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={(query) =>
                            new Promise((resolve, reject) => {
                              const { orderBy, orderDirection } = query;

                              let url =
                                API +
                                "processing/manageProcessing/Bucket/?";
                              url += "per_page=" + query.pageSize;
                              url += "&page=" + (query.page + 1);
                              url += "&search=" + query.search;
                              url += `&request_date=${selectedValue3
                                ? Helper.DatePicker(selectedValue3)
                                : ""
                                }`;
                              if (orderBy) {
                                url += `&orderBy=${orderBy.field}`;
                                url += `&orderDirection=${orderDirection}`;
                              }
                              fetch(url, { headers: authHeader() })
                                .then((response) => response.json())
                                .then((result) => {
                                  resolve({
                                    data:
                                      query.orderBy && query.orderDirection
                                        ? _.orderBy(
                                          result.data,
                                          [query.orderBy.field],
                                          [query.orderDirection]
                                        )
                                        : result.data,
                                    page: result.page - 1,
                                    totalCount: result.total,
                                  });
                                });
                            })
                          }
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              fontSize: 12,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: false,
                            toolbar: false,
                            paging: true,
                            pageSize: 10, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [10, 20, 30, 40],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            actionsColumnIndex: -1,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ContentLoader
              viewBox="0 0 1000 550"
              backgroundColor="rgba(0,0,0,0.06)"
              foregroundColor="rgba(0,0,0,0.12)"
            >
              <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
              <circle cx="879" cy="123" r="11" />
              <circle cx="914" cy="123" r="11" />
              <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
              <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
              <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
              <circle cx="880" cy="184" r="11" />
              <circle cx="915" cy="184" r="11" />
              <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
              <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
              <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
              <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="242" r="11" />
              <circle cx="916" cy="242" r="11" />
              <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="303" r="11" />
              <circle cx="917" cy="303" r="11" />
              <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
              <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="363" r="11" />
              <circle cx="916" cy="363" r="11" />
              <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="424" r="11" />
              <circle cx="917" cy="424" r="11" />
              <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
              <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
              <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
              <circle cx="882" cy="484" r="11" />
              <circle cx="917" cy="484" r="11" />
              <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
              <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
              <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
              <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
              <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
              <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
              <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
            </ContentLoader>
          )}
        </div>
      </div>
    </>
  );
}

export default GenerateAgingBucket;
